export default __webpack_public_path__ + "static/media/background3.6cd0cace.jpg";